<template>
  <b-modal id="customFieldEditModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.customField.update.header') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="created" class="alert alert-success" role="status">{{ created.fieldName }} {{$t('notifications.created')}}.</div>
        <div v-if="updated" class="alert alert-success" role="status">{{ updated.fieldName }} {{$t('notifications.updated')}}.</div>
        <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
        <div v-if="error" class="alert alert-danger" role="alert">
          <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
        </div>
        <div v-if="deleteError" class="alert alert-danger" role="alert">
          <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <CustomFieldForm :item="item" :fieldTypes="fieldTypes"></CustomFieldForm>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row v-for="(customFieldValue, index) in item.fieldValues" v-bind:key="'customFieldValue-' + index">
          <b-col>
            <CustomFieldValue :item="customFieldValue" :items="item.fieldValues" :index="index"></CustomFieldValue>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="!isLoading">
      <b-col>
        <div class="float-right">
          <button v-if="!updated" type="submit" class="btn btn-success" @click="storeObject()">{{$t('buttons.save')}}</button>
          <b-button class="btn btn-secondary" @click="closeModal()">{{ closeText }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CustomFieldForm from '../CustomFieldForm'
import CustomFieldValue from '../CustomFieldValue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CustomFieldEditModal',
  components: {
    CustomFieldForm,
    CustomFieldValue
  },
  props: {
    fieldTypes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      routeName: '',
      closeText: this.$t('buttons.close'),
      itemIndex: 0,
      item: {
        fieldName: '',
        fieldType: 'input',
        fieldDefaultValue: '',
        fieldLabel: '',
        fieldDescription: '',
        fieldRequired: 0,
        fieldReadonly: 0,
        onlyNumbersAllowed: 0,
        allowedDaysBack: null,
        allowedDaysAhead: null,
        minValue: null,
        maxValue: null,
        fieldValues: [],
        disabledRoles: [],
        idUserDataClientTypes: [],
        showInTable: 0
      }
    }
  },
  created () {
    this.routeName = this.$route.name
  },
  computed: {
    ...mapGetters({
      isLoading: 'excmcustomfield/update/isLoading',
      error: 'excmcustomfield/update/error',
      deleteError: 'excmcustomfield/del/error',
      deleteLoading: 'excmcustomfield/del/isLoading',
      created: 'excmcustomfield/create/created',
      deleted: 'excmcustomfield/del/deleted',
      retrieved: 'excmcustomfield/update/retrieved',
      updated: 'excmcustomfield/update/updated',
      violations: 'excmcustomfield/update/violations'
    }),
    show () {
      return this.$store.state.modals.customField.update.show
    },
    index () {
      return this.$store.state.modals.customField.update.index
    },
    customFieldObject () {
      return this.$store.state.modals.customField.update.customFieldObject
    },
    customFieldValueObject () {
      return this.$store.state.modals.customFieldValue.create.customFieldValueObject
    }
  },
  watch: {
    show: function (val) {
      this.openModal()
    },
    index: function (val) {
      this.openModal()
    },
    customFieldObject: function (val) {
      this.openModal()
    },
    customFieldValueObject: function (val) {
      this.appendNewValue(val)
    },
    updated: function (updated) {
      if (!updated) {
        return
      }
      this.closeModal()
    }
  },
  methods: {
    ...mapActions({
      createReset: 'excmcustomfield/create/reset',
      deleteItem: 'excmcustomfield/del/del',
      delReset: 'excmcustomfield/del/reset',
      retrieve: 'excmcustomfield/update/retrieve',
      updateReset: 'excmcustomfield/update/reset',
      update: 'excmcustomfield/update/update',
      updateRetrieved: 'excmcustomfield/update/updateRetrieved'
    }),
    appendNewValue (value) {
      if (Object.entries(value).length > 0 && this.modalShow === 1) {
        this.item.fieldValues.push(Object.assign({}, value))
        this.$store.state.modals.customFieldValue.create.customFieldValueObject = {}
      }
    },
    openModal () {
      if (this.show === 1 && Object.entries(this.customFieldObject).length > 0 && this.index > -1) {
        // this.item = Object.assign({}, this.$store.state.modals.customField.update.customFieldObject)
        this.item = JSON.parse(JSON.stringify(this.$store.state.modals.customField.update.customFieldObject))
        this.itemIndex = this.$store.state.modals.customField.update.index
        this.$store.state.modals.customField.update.show = 0
        this.$store.state.modals.customField.update.customFieldObject = {}
        this.$store.state.modals.customField.update.index = -1
        this.modalShow = 1
        this.$bvModal.show('customFieldEditModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('customFieldEditModal')
    },
    resetData () {
      this.item = {
        fieldName: '',
        fieldType: 'input',
        fieldDefaultValue: '',
        fieldLabel: '',
        fieldDescription: '',
        fieldRequired: 0,
        fieldReadonly: 0,
        onlyNumbersAllowed: 0,
        allowedDaysBack: null,
        allowedDaysAhead: null,
        minValue: null,
        maxValue: null,
        fieldValues: [],
        disabledRoles: [],
        idUserDataClientTypes: []
      }
      this.itemIndex = 0
      this.modalShow = 0
      if (
        this.routeName === 'EXCMCaseTypeShow' ||
        this.routeName === 'EXCMTaskTypeShow' ||
        this.routeName === 'EXCMCaseTypeUpdate' ||
        this.routeName === 'EXCMTaskTypeUpdate') {
        this.$store.state.excmcustomfield.update.updated = null
      }
    },
    storeObject () {
      if (this.routeName === 'EXCMCaseTypeCreate' || this.routeName === 'EXCMTaskTypeCreate') {
        this.$store.state.modals.customField.update.customFieldObjectUpdated = Object.assign({}, this.item)
        this.$store.state.modals.customField.update.indexUpdated = this.itemIndex
        this.$bvModal.hide('customFieldEditModal')
      } else if (
        this.routeName === 'EXCMCaseTypeShow' ||
        this.routeName === 'EXCMTaskTypeShow' ||
        this.routeName === 'EXCMCaseTypeUpdate' ||
        this.routeName === 'EXCMTaskTypeUpdate') {
        let item = Object.assign({}, this.item)
        if (item.caseType && item.caseType['@id']) {
          item.caseType = item.caseType['@id']
        }
        if (item.taskType && item.taskType['@id']) {
          item.taskType = item.taskType['@id']
        }
        if (item.allowedDaysAhead) {
          item.allowedDaysAhead = parseInt(item.allowedDaysAhead)
        }
        if (item.allowedDaysBack) {
          item.allowedDaysBack = parseInt(item.allowedDaysBack)
        }
        if (item.minValue) {
          item.minValue = parseInt(item.minValue)
        }
        if (item.maxValue) {
          item.maxValue = parseInt(item.maxValue)
        }
        this.$store.state.excmcustomfield.update.retrieved = item
        // delete item.fieldValues
        this.update()
      }
    }
  }
}
</script>
